import ActionCard from "@/components/ActionCard";
import SectionHeading from "@/components/SectionHeading";
import useCapabilities, { DOMAIN } from "@/hooks/useCapabilities";
import usePageTitle from "@/hooks/usePageTitle";
import { useNavigate } from "@/router";
import TabLayout from "../_TabLayout";

export default function FinancePage() {
  usePageTitle("/billing/finance", "Billing | Finance");
  const navigate = useNavigate();
  const { capabilities } = useCapabilities();

  const canViewBenefitPrograms = capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS);

  return (
    <TabLayout>
      <SectionHeading body="Manage finance programs and contributions" />
      {canViewBenefitPrograms && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem]">
          <div>
            <ActionCard
              actionFn={() => navigate("/billing/finance/grp")}
              iconName="volunteer_activism"
              title="Golf Retirement Plus"
              text="Manage member and sponsor contributions for the Golf Retirement Plus benefit program."
            />
          </div>
        </div>
      )}
    </TabLayout>
  );
}
